import { render, staticRenderFns } from "./MealFeedbackStatsPanel.vue?vue&type=template&id=b3e41fa4&scoped=true&"
import script from "./MealFeedbackStatsPanel.vue?vue&type=script&lang=js&"
export * from "./MealFeedbackStatsPanel.vue?vue&type=script&lang=js&"
import style0 from "./MealFeedbackStatsPanel.vue?vue&type=style&index=0&id=b3e41fa4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3e41fa4",
  null
  
)

export default component.exports